import { ReactElement } from 'react';
// import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

type ProtectedRouteProps = {
  children: ReactElement;
};

export function ProtectedRoute({ children }: ProtectedRouteProps): ReactElement {
  // const authToken = Cookies.get('authToken');
  // const { t } = useTranslation('common');
  // React.useEffect(() => {
  //   if (!authToken) {
  //     window.location.href = process.env.REACT_APP_PORTAL_URL;
  //   }
  // }, [authToken]);

  // if (!authToken) {
  //   return <p>{t('common.unauthorized')}</p>;
  // }

  return children || <Outlet />;
}
